import React from 'react';
import './AnimatedButton.css';

const AnimatedButton = React.forwardRef(({ 
  children, 
  onClick, 
  className = '', 
  style = {}, 
  type = 'button',
  disabled = false,
  bgColor = '#FF7722',
  textColor = '#ffffff',
  hoverBgColor = '#FF5500',
  hoverTextColor = '#ffffff',
  icon = null,
  rightIcon = null
}, ref) => {
  // If children is a string, we split it for the staggered effect.
  // Otherwise we just render it directly (fallback for icon-only buttons).
  const isString = typeof children === 'string';
  const text = isString ? children : '';
  const letters = text.split('');

  return (
    <button
      ref={ref}
      type={type}
      className={`animated-btn ${className}`}
      style={{
        '--btn-bg': bgColor,
        '--btn-text': textColor,
        '--btn-hover-bg': hoverBgColor,
        '--btn-hover-text': hoverTextColor,
        ...style
      }}
      onClick={onClick}
      disabled={disabled}
    >
      <span className="animated-btn-fill"></span>
      <span className="animated-btn-content">
        {icon && <span className="animated-btn-icon">{icon}</span>}
        {isString ? (
          <span className="animated-btn-text-wrapper">
            <span className="animated-btn-text original">
              {letters.map((char, i) => (
                <span 
                  key={`orig-${i}`} 
                  className="char"
                  style={{ transitionDelay: `${i * 0.02}s` }}
                >
                  {char === ' ' ? '\u00A0' : char}
                </span>
              ))}
            </span>
            <span className="animated-btn-text clone" aria-hidden="true">
              {letters.map((char, i) => (
                <span 
                  key={`clone-${i}`} 
                  className="char"
                  style={{ transitionDelay: `${i * 0.02}s` }}
                >
                  {char === ' ' ? '\u00A0' : char}
                </span>
              ))}
            </span>
          </span>
        ) : (
          children
        )}
        {rightIcon && <span className="animated-btn-icon">{rightIcon}</span>}
      </span>
    </button>
  );
});

export default AnimatedButton;
